<template>
  <form>
    <v-layout
      wrap
      style="padding-top: 20px;"
    >
      <v-flex xs3 />
      <v-flex xs3>
        <div
          class="text-center"
        >
          <h5>{{ $t('settings.colors.primary') }}</h5>
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center"
        >
          <h5>{{ $t('settings.colors.secundary') }}</h5>
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center"
        >
          <h5>{{ $t('settings.colors.content') }}</h5>
        </div>
      </v-flex>

      <v-flex xs12 style="height: 10px;" />
      <!-- BGCOLOR -->
      <v-flex xs3>
        <div
          class="text-left pt-2"
        >
          {{ $t('settings.colors.backgroundColor') }}
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <custom-color-picker
            v-if="BGColor"
            label=""
            :width="'80%'"
            :icon="'mdi-format-color-fill'"
            :color="BGColor"
            :onChangeColor="handleChangeBGColor"
          />
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <custom-color-picker
            v-if="BGColorSecundary"
            label=""
            :width="'80%'"
            :icon="'mdi-format-color-fill'"
            :color="BGColorSecundary"
            :onChangeColor="handleChangeBGColorSecundary"
          />
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <custom-color-picker
            v-if="BGColorContent"
            label=""
            :width="'80%'"
            :icon="'mdi-format-color-fill'"
            :color="BGColorContent"
            :onChangeColor="handleChangeBGColorContent"
          />
        </div>
      </v-flex>

      <v-flex xs12 style="height: 10px;">
      </v-flex>
      <!-- FontColor -->
      <v-flex xs3>
        <div
          class="text-left pt-2"
        >
          {{ $t('settings.colors.fontColor') }}
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <custom-color-picker
            v-if="Color"
            label=""
            :width="'80%'"
            :icon="'mdi-format-color-text'"
            :color="Color"
            :onChangeColor="handleChangeColor"
          />
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <custom-color-picker
            v-if="ColorSecundary"
            label=""
            :width="'80%'"
            :icon="'mdi-format-color-text'"
            :color="ColorSecundary"
            :onChangeColor="handleChangeColorSecundary"
          />
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <custom-color-picker
            v-if="ColorContent"
            label=""
            :width="'80%'"
            :icon="'mdi-format-color-text'"
            :color="ColorContent"
            :onChangeColor="handleChangeColorContent"
          />
        </div>
      </v-flex>

      <v-flex xs12 style="height: 10px;">
      </v-flex>
      <!-- Font -->
      <v-flex xs3>
        <div
          class="text-left pt-2"
          style="margin-top: 20px;"
        >
          {{ $t('settings.colors.font') }}
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <v-autocomplete
            v-if="fonts"
            :value="Font"
            :items="fonts"
            :filter="fontsFilter"
            :label="$t('settings.colors.font')"
            color="dtouch"
            item-text="Name"
            item-value="Name"
            single-line
            style="width:80%;margin-left:10%;"
            @input="handleChangeFont"
          />
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <v-autocomplete
            v-if="fonts"
            :value="FontSecundary"
            :items="fonts"
            :filter="fontsFilter"
            :label="$t('settings.colors.font')"
            color="dtouch"
            item-text="Name"
            item-value="Name"
            single-line
            style="width:80%;margin-left:10%;"
            @input="handleChangeFontSecundary"
          />
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <v-autocomplete
            v-if="fonts"
            :value="FontContent"
            :items="fonts"
            :filter="fontsFilter"
            :label="$t('settings.colors.font')"
            color="dtouch"
            item-text="Name"
            item-value="Name"
            single-line
            style="width:80%;margin-left:10%;"
            @input="handleChangeFontContent"
          />
        </div>
      </v-flex>
      <v-flex xs12 style="height: 10px;">
      </v-flex>
      <!-- FontSize -->
      <v-flex xs3>
        <div
          class="text-left pt-2"
        >
          {{ $t('settings.colors.fontSize') }}
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <v-slider
            :value="FontSize"
            :color="enterpriseColor"
            min="0"
            max="50"
            thumb-label
            style="width:80%;margin-left:10%;"
            @input="handleChangeFontSize"
          />
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <v-slider
            :value="FontSizeSecundary"
            :color="enterpriseColor"
            min="0"
            max="50"
            thumb-label
            style="width:80%;margin-left:10%;"
            @input="handleChangeFontSizeSecundary"
          />
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <v-slider
            :value="FontSizeContent"
            :color="enterpriseColor"
            min="0"
            max="50"
            thumb-label
            style="width:80%;margin-left:10%;"
            @input="handleChangeFontSizeContent"
          />
        </div>
      </v-flex>
      <v-flex xs12 style="height: 10px;">
      </v-flex>
      <!-- format -->
      <v-flex xs3>
        <div
          class="text-left pt-2"
        >
          {{ $t('settings.colors.textFormat') }}
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <v-btn-toggle v-model="TextFormat" @change="handleChangeTextFormat">
            <v-btn :value="1">
              <v-icon>mdi-format-letter-case-upper</v-icon>
            </v-btn>

            <v-btn :value="2">
              <v-icon>mdi-format-letter-case-lower</v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
          <v-btn-toggle v-model="TextFormatSecundary" @change="handleChangeTextFormatSecundary">
            <v-btn :value="1">
              <v-icon>mdi-format-letter-case-upper</v-icon>
            </v-btn>

            <v-btn :value="2">
              <v-icon>mdi-format-letter-case-lower</v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-center pt-2"
        >
        </div>
      </v-flex>
      <v-flex xs12>
        <v-divider style="margin: 10px 0 20px 0"/>
      </v-flex>
      <v-flex xs6>
        <v-layout
          wrap
        >
          <v-flex xs6>
            <v-switch
              value :input-value="withGradient"
              :label="$t('settings.colors.shadowMenu')"
              :color="enterpriseColor"
              hide-details
              @change="handleChangeGradiant"
            />
            <v-switch
              value :input-value="withGradientSubmenu"
              :label="$t('settings.colors.shadowSubmenu')"
              :color="enterpriseColor"
              hide-details
              @change="handleChangeGradiantSubmenu"
            />
          </v-flex>
          <v-flex xs6>
            <v-switch
              value :input-value="withLine"
              :label="$t('settings.colors.line')"
              :color="enterpriseColor"
              hide-details
              @change="handleChangeLine"
            />
          </v-flex>
        </v-layout>
        <!-- <v-checkbox v-model="isGradient"
        @change="handleChangeGradiant"
        :label="$t('settings.colors.isGradient')" /> -->
      </v-flex>
      <v-flex xs6
        style="padding-bottom: 20px;"
      >
        <div
          class="text-right pt-2"
        >
          <v-btn class="mr-4" @click="handleClear">{{ $t('common.cancel') }}</v-btn>
          <v-btn dark :color="enterpriseColor" @click="handleSubmit">{{ $t('common.save') }}</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-snackbar
      top
      right
      v-model="snackbar"
      :timeout="timeout"
      :color="messageColor"
    >
      {{ message }}
      <v-btn
        color="black"
        text
        @click="snackbar = false"
      >
        {{ $t('common.close') }}
      </v-btn>
    </v-snackbar>
  </form>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import utils from '@/services/utils.js'
  import CustomColorPicker from '@/components/CustomColorPicker'
  export default {
    components: {
      CustomColorPicker
    },
    props: {
    },
    data: () => ({
      fonts: null,
      snackbar: false,
      message: false,
      messageColor: 'success',
      timeout: 3000,
    }),
    computed: {
      ...mapState('app',['withLine', 'withGradientSubmenu', 'withGradient', 'enterpriseID','BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary', 'BGColorContent', 'ColorContent', 'GlobalFont', 'Font', 'FontSecundary', 'FontContent', 'FontSize', 'FontSizeSecundary', 'FontSizeContent', 'TextFormat', 'TextFormatSecundary']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    mounted () {
      api.getAll('utils/fonts', true, 1, 10000, '').then(response => {
        this.fonts = response.data
      })
    },
    methods: {
      handleChangeGradiant () {
        this.$store.state.app.withGradient = !this.withGradient
      },
      handleChangeGradiantSubmenu () {
        this.$store.state.app.withGradientSubmenu = !this.withGradientSubmenu
      },
      handleChangeLine () {
        this.$store.state.app.withLine = !this.withLine
      },
      fontsFilter (item, queryText) {
        const textOne = item.Name.toLowerCase()
        const searchText = queryText ? queryText.toLowerCase() : ''

        return textOne.indexOf(searchText) > -1
      },
      handleChangeFont (font) {
        this.$store.state.app.Font = font
      },
      handleChangeFontSecundary (font) {
        this.$store.state.app.FontSecundary = font
      },
      handleChangeFontContent (font) {
        this.$store.state.app.FontContent = font
      },
      handleChangeFontSize (font) {
        this.$store.state.app.FontSize = font
      },
      handleChangeFontSizeSecundary (font) {
        this.$store.state.app.FontSizeSecundary = font
      },
      handleChangeFontSizeContent (font) {
        this.$store.state.app.FontSizeContent = font
      },
      handleChangeBGColor (color) {
        this.$store.state.app.BGColor = color
      },
      handleChangeColor (color) {
        this.$store.state.app.Color = color
      },
      handleChangeBGColorSecundary (color) {
        this.$store.state.app.BGColorSecundary = color
      },
      handleChangeColorSecundary (color) {
        this.$store.state.app.ColorSecundary = color
      },
      handleChangeBGColorContent (color) {
        this.$store.state.app.BGColorContent = color
      },
      handleChangeColorContent (color) {
        this.$store.state.app.ColorContent = color
      },
      handleChangeTextFormat (value) {
        this.$store.state.app.TextFormat = value
      },
      handleChangeTextFormatSecundary (value) {
        this.$store.state.app.TextFormatSecundary = value
      },
      handleSubmit () {
        const body = {
          BGColor: this.BGColor,
          Color: this.Color,
          BGColorSecundary: this.BGColorSecundary,
          ColorSecundary: this.ColorSecundary,
          BGColorContent: this.BGColorContent,
          ColorContent: this.ColorContent,
          GlobalFont: this.GlobalFont,
          GradientMenu: this.withGradient,
          GradientSubmenu: this.withGradientSubmenu,
          LineMenu: this.withLine,
          Font: this.Font,
          FontSecundary: this.FontSecundary,
          FontContent: this.FontContent,
          FontSize: this.FontSize,
          FontSizeSecundary: this.FontSizeSecundary,
          FontSizeContent: this.FontSizeContent,

          TextFormat: this.TextFormat,
          TextFormatSecundary: this.TextFormatSecundary
        }
        api.updateItem('enterprises', this.enterpriseID.concat('/colors'), body)
          .then(response => {
            if (!response.data.error) {
              this.message = this.$t('settings.colors.messages.update')
              this.messageColor = 'success'
              this.snackbar = true
            }
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      handleClear () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.$store.state.app.BGColor = response.BGColor
          this.$store.state.app.Color = response.Color
          this.$store.state.app.BGColorSecundary = response.BGColorSecundary
          this.$store.state.app.ColorSecundary = response.ColorSecundary
          this.$store.state.app.BGColorContent = response.BGColorContent
          this.$store.state.app.ColorContent = response.ColorContent
          this.$store.state.app.GlobalFont = response.GlobalFont
        })
      },
    },
  }
</script>
<style lang="postcss" scoped>
  h5 {
    text-transform: uppercase;
    font-weight: 400 !important;
  }
</style>

